<template>
  <div>
    <div class="step-single form active" v-show="step.form">
      <div class="step-title">{{ T__("Select Participant Type") }}</div>
      <div class="form" @submit.prevent>
        <form-row :validator="$v.form.relationship_type">
          <ul class="selector block">
            <li>
              <input
                type="radio"
                id="one-on-one"
                name="participant-type"
                v-model="form.relationship_type"
                value="1to1"
              />
              <label for="one-on-one">
                <div class="txt-h4">{{ T__("One-on-One") }}</div>
                <div class="txt-help">
                  {{ T__("Allow invitees to book individual slots with you.") }}
                </div>
              </label>
            </li>
            <li class="disabled">
              <input
                type="radio"
                name="participant-type"
                id="invitee-group"
                disabled
              />
              <label for="invitee-group">
                <div class="txt-h4">
                  {{ T__("Group") }}<em class="coming-soon">COMING SOON</em>
                </div>
                <div class="txt-help">
                  {{
                    T__(
                      "Allow multiple invitees to book the same slot. Useful for tours, webinars, classes, workshops, etc."
                    )
                  }}
                </div>
              </label>
            </li>
            <li class="disabled">
              <input
                type="radio"
                id="collective"
                name="participant-type"
                v-model="form.relationship_type"
                value="collective"
                disabled
              />
              <label for="collective">
                <div class="txt-h4">
                  {{ T__("Collective") }}<span>TEAM</span
                  ><em class="coming-soon">COMING SOON</em>
                </div>
                <div class="txt-help">
                  {{
                    T__(
                      "Allow invitees to book slots when all assigned hosts are available."
                    )
                  }}
                </div>
              </label>
            </li>
            <li class="disabled">
              <input
                type="radio"
                id="round_robin"
                name="participant-type"
                v-model="form.relationship_type"
                value="round_robin"
                disabled
              />
              <label for="round_robin">
                <div class="txt-h4">
                  {{ T__("Round Robin") }}<span>TEAM</span
                  ><em class="coming-soon">COMING SOON</em>
                </div>
                <div class="txt-help">
                  {{ T__("Assign slots to available hosts, cyclically.") }}
                </div>
              </label>
            </li>
          </ul>
        </form-row>

        <div class="wpc-form-row">
          <button
            type="button"
            class="wpc-btn primary lg"
            @click="$emit('validate-may-navigate-or-submit', 1)"
          >
            {{ T__("Continue") }}
          </button>
        </div>
      </div>
    </div>
    <div class="step-single summary" v-show="step.summary">
      <div class="step-title">
        <span>{{ T__("Participant type") }}</span>
        <a @click="$emit('set-active-step-and-toggle', 1)">{{ T__("EDIT") }}</a>
      </div>
      <div class="step-summary-content">{{ T__("One-on-One") }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ServiceFormStep1",
  props: {
    view: {
      type: String
    },
    step: {
      type: Object,
      required: true
    },
    form: {
      type: Object,
      required: true
    },
    $v: {}
  },
  mounted() {
    if (this.view == "add") {
      this.$props.step.summary = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.txt-h4 span {
  border: 1px solid #567bf3;
  background-color: #e4e9f5;
  color: #567bf3;
  font-size: 11px;
  padding: 2px 3px 1px;
  border-radius: 3px;
  margin-left: 5px;
}
#wpcal_admin_app ul.selector li.disabled em.coming-soon {
  background-color: #afb6d1;
  padding: 1px 5px;
  border-radius: 3px;
  float: right;
  font-size: 11px;
  font-style: normal;
  color: #131336;
  margin-top: 0;
}
</style>
